<script>
import DispersionTable from "@components/treasury/DispersionTable.vue";

export default {
  name: "TreasuryDispersionTables",
  components: {DispersionTable},
  props: {
    identity: {
      type: String,
      required: true
    },
    supportRefunds: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: false
    },
    showProjectInfo: {
      type: Boolean,
      default: false
    },
    showFiscalInfo: {
      type: Boolean,
      default: false
    },
    disperseAction: {
      type: String,
      required: true
    },
    refundAction: {
      type: String,
      required: true
    },
    dispersions: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: "success"
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    pendingDispersions: function () {
      return this.dispersions.filter(dispersion => dispersion.status === 1);
    },
    inProcessDispersions: function () {
      return this.dispersions.filter(dispersion => dispersion.status === 2);
    },
    returnedDispersions: function () {
      return this.dispersions.filter(dispersion => dispersion.status === 4);
    },
  },
}
</script>

<template>
  <div class="container mt-5">
    <vs-divider :color="color">{{ title }}</vs-divider>
    <dispersion-table
        :identity="identity"
        :expand="expand"
        :disperse-action="disperseAction"
        :refund-action="refundAction"
        action="pending"
        :show-project-info="showProjectInfo"
        :show-fiscal-info="showFiscalInfo"
        title="Dispersiones pendientes"
        :dispersions="pendingDispersions"></dispersion-table>

    <dispersion-table
        :identity="identity"
        :expand="expand"
        :disperse-action="disperseAction"
        :refund-action="refundAction"
        action="in-process"
        :show-project-info="showProjectInfo"
        :show-fiscal-info="showFiscalInfo"
        title="Dispersiones en proceso"
        :dispersions="inProcessDispersions"></dispersion-table>

    <dispersion-table
        :identity="identity"
        :show-project-info="showProjectInfo"
        :show-fiscal-info="showFiscalInfo"
        :disperse-action="disperseAction"
        :refund-action="refundAction"
        action="refunded"
        v-if="supportRefunds"
        title="Dispersiones fallidas"
        :dispersions="returnedDispersions"></dispersion-table>
  </div>
</template>

<style scoped>

</style>